import useDataHook from "./useDataHook";
function LocalFavorites() {
    const [loading, Favorites, errors] = useDataHook('/LocalFavoriteTypes/GetLocalFavorites', null);
    return (<>
        <h3 className="display-3"> Local Favorites</h3>
        <p className="h6">
            Lisa and I live on the border of Rensselear and Columbia counties in New York.  Check here often as we build a list of favorite places
            we have found in the area. Check back often as we find more locations.
        </p>
        {loading ? <div>Loading...Please wait</div> : <ul>
            {Favorites.map((fav) =>
                <li key={fav.localFavoriteId}  >
                    <h3>{fav.placeName}</h3>
                    <a href={fav.url} rel="noreferrer noopener" target="_blank"   >{fav.url}</a><br></br>
                    <i>location:{fav.placeCity} {fav.placeState}   </i>
                    {fav.localFavoriteTypeName}
                    <p>{fav.placeDescription}</p>
                </li>)
            }
        </ul>
        }
        {errors && <div>{errors}</div>}</>);
}
export default LocalFavorites

